import React from "react";
import { Button, Row, Col } from "antd";
import styles from "./styles/multiSelectFooter.scss";

const MultiSelectFooter = ({ onCancel, onOk }) => (
  <Row gutter={15} className={styles.wrapper}>
    <Col span={12}>
      <Button className={styles.cancelButton} onClick={onCancel}>
        {"Odustani"}
      </Button>
    </Col>
    <Col span={12}>
      <Button type="primary" className={styles.okButton} onClick={onOk}>
        {"Primjeni"}
      </Button>
    </Col>
  </Row>
);

export default MultiSelectFooter;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiSelectModal/MultiSelectFooter.tsx